import { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';
import Icon, { IconKey } from './Icon';

export type HighlightContainerType = 'success' | 'warning' | 'error';

const config: Record<
    HighlightContainerType,
    { bg: string; iconKey: IconKey; iconColor: string }
> = {
    success: {
        bg: 'bg-green/15',
        iconKey: 'checkCircleOutline',
        iconColor: 'text-green',
    },
    warning: {
        bg: 'bg-yellow/20',
        iconKey: 'report_problem',
        iconColor: 'text-yellow',
    },
    error: {
        bg: 'bg-red/15',
        iconKey: 'error',
        iconColor: 'text-red',
    },
};

interface Props {
    type: HighlightContainerType;
    title: ReactNode;
    body: ReactNode;
    className?: string;
}

const HighlightContainer = ({ type, title, body, className }: Props) => {
    const { bg, iconKey, iconColor } = config[type];

    return (
        <div
            className={twMerge(
                'flex gap-3 rounded-sm px-4 py-3 text-black dark:text-white',
                bg,
                className,
            )}
        >
            <Icon
                iconKey={iconKey}
                className={twMerge('size-5 shrink-0', iconColor)}
            />
            <div className="flex flex-col gap-1 text-sm">
                <div className="font-medium">{title}</div>
                {body}
            </div>
        </div>
    );
};

export default HighlightContainer;
